import React from 'react';
import ReactDOM from 'react-dom/client';
import {registerLicense} from '@syncfusion/ej2-base'
import './index.css'; // Promijeni u standardni CSS
import App from './App';
registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF1cVGhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEBjWn9acXdWTmBfV0N/Vw==')
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);